// extracted by mini-css-extract-plugin
export var parcelRow = "_qw-0";